import { SearchField, SelectField } from "@aws-amplify/ui-react";
import React, { useContext, useEffect, useState } from "react";
import LeadsContext from "../context/leads";

function Filters({ order, setorder, canal, setCanal, asesor, setAsesor, user}) {
  const { models, modelsOrig, Search, FilterChannel, FilterConekta, FilterAdvicer } = useContext(LeadsContext);
  const [channels, setChannels] = useState([])
  const [asesores, setAsesores] = useState([])
  const [busqueda, setBusqueda]= useState("");

  useEffect(()=>{
    Channels();
    AsesoresC();
  },[models])

  const handleChange=(e)=>{
    setBusqueda(e.target.value);
    Search(e.target.value);
  }

  const handleChangeChannel=(e)=>{
    console.log(e.target.value)
    setCanal(e.target.value)
    FilterChannel(e.target.value);
  }

  const handleChangeConekta=(e)=>{
    setAsesor(e.target.value)
    FilterConekta(e.target.value);
  }
  const handleChangeAdvicer=(e)=>{
    setAsesor(e.target.value)
    FilterAdvicer(e.target.value);
  }

  function Channels(){
    let optionCanales = modelsOrig.reduce((canales,item)=>{
        if(!canales.includes(item.channel)){
          canales.push(item.channel);
        }
        return canales ;
      },[])
      setChannels(optionCanales);
  } 

  function AsesoresC(){
    let optionAsesor = modelsOrig.reduce((asesor,item)=>{
      let abuscar = user ==="Contact Center" ? item.conekta : item.advicer;
        if(!asesor.includes(abuscar)){
            asesor.push(abuscar);
        }
        return asesor ;
      },[])
      setAsesores(optionAsesor);
  } 
  const onClearSearch = () => {
    Search("");
  };
  return (
    <div className="flex sm:flex-col md:flex-row gap-6 items-end px-14 flex-wrap">
      <SelectField
        label="Fecha"
        placeholder="Seleccionar"
        width="100%"
        minWidth={"180px"}
        grow="1"
        shrink="1"
        basis="0"
        value={order}
        onChange={(e)=>{
            let { value } = e.target;
            setorder(value)
        }}
      >
        <option value="1">Ascendente</option>
        <option value="2">Descendente</option>
      </SelectField>
      <SelectField
        label="Canal"
        placeholder="Seleccionar"
        width="100%"
        minWidth={"180px"}
        grow="1"
        shrink="1"
        basis="0"
        value={canal}
        onChange={handleChangeChannel}
      >
        {channels.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </SelectField>
      <SelectField
        label={user === "Contact Center" ? "Contact Center" : "Asesor"}
        placeholder="Seleccionar"
        width="100%"
        minWidth={"180px"}
        grow="1"
        shrink="1"
        basis="0"
        value={asesor}
        onChange={user === "Contact Center" ? handleChangeConekta : handleChangeAdvicer }
      >
        {asesores.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </SelectField>
      
      <SearchField
        placeholder="Buscar Lead"
        width="100%"
        minWidth={"180px"}
        grow="1"
        shrink="1"
        basis="0"
        onClear={onClearSearch}
        onChange={handleChange}
      ></SearchField>
    </div>
  );
}

export default Filters;
